import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setLoading } from "./LoadingSlice";
import Unauthorized from "../Admin/Unauthorized";
import BaseUrl from "../../BaseUrl";
const headers = Unauthorized.Actionsauthorized();

const API_BASE_URL = `${BaseUrl.authurl}Kyc/`;
const auth = BaseUrl.authurl

export const getPendingDoctorsWithKYC = createAsyncThunk(
  "kyc/getPendingDoctors",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}GetDoctorsWithPendingKyc`, { headers });
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response.data || "An error occurred");
    }
  }
);

export const fetchDepartments = createAsyncThunk(
  'departments/fetchDepartments',
  async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await fetch(`${auth}Departments/GetAllDepartments`, { headers });
      if (!response.ok) {
        throw new Error('Failed to fetch departments');
      }
      const data = await response.json();
      return data;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const acceptKyc = createAsyncThunk(
  'kyc/acceptKyc',
  async ({ doctorId, departmentId, departmentName, consultationFee }, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await axios.patch(
        `${API_BASE_URL}AcceptKyc?doctorId=${doctorId}&departmentId=${departmentId}&departmentName=${departmentName}&fee=${consultationFee}`,
        null,
        { headers }
      )
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const rejectKyc = createAsyncThunk(
  'kyc/rejectKyc',
  async ({ doctorId, }, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      console.log('Headers:', headers);
      console.log('DoctorId:', doctorId);
      
      const response = await axios.patch(
        `${API_BASE_URL}RejectKyc?doctorId=${doctorId}`,null,
        { headers }
      );
      
     
      
      return response.data;
    } catch (error) {
      console.error('Reject KYC error:', error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

const manageKycSlice = createSlice({
  name: "managependingkyc",
  initialState: {
    pendingDoctors: [],
    loading: false,
    error: null,
    departments: [],
    status: 'idle', // Added missing status field
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPendingDoctorsWithKYC.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPendingDoctorsWithKYC.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingDoctors = action.payload;
      })
      .addCase(getPendingDoctorsWithKYC.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.pendingDoctors = [];
      })
      .addCase(fetchDepartments.pending, (state) => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        state.departments = action.payload;
      })
      .addCase(fetchDepartments.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(acceptKyc.pending, (state) => {
        state.loading = true;
      })
      .addCase(acceptKyc.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(acceptKyc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(rejectKyc.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectKyc.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(rejectKyc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default manageKycSlice.reducer;